<template>
    <div class="row g-6">
        <div class="col-12">
            <div class="d-flex justify-content-center border rounded pt-2">
                <img src="@/assets/vuexy/img/illustrations/wizard-create-deal-girl-with-laptop-light.png"
                    alt="wizard-create-deal"
                    data-app-light-img="illustrations/wizard-create-deal-girl-with-laptop-light.png"
                    data-app-dark-img="illustrations/wizard-create-deal-girl-with-laptop-dark.png" width="650"
                    class="img-fluid" />
            </div>
        </div>
        <div class="col-12">
            <div class="row strategy-type-row align-items-stretch">
                <p>Шаг 1. Выберите, как должна работать ваша стратегия ценообразования</p>
                <div class="col-md mb-md-0 mb-6">
                    <div class="form-check custom-option custom-option-icon mb-0 h-100">
                        <label class="form-check-label custom-option-content" for="valueTypePrice">
                            <span class="custom-option-body">
                                <i class="ti ti-tag-starred ti-sm"></i>

                                <span class="custom-option-title">Удержание цены</span>
                                <small>Вы указываете цену для товара(ов), а система удерживает её</small>
                            </span>
                            <input name="value-type" class="form-check-input" type="radio" value="price"
                                v-model="localStrategy.pricing_parameters.type" id="valueTypePrice" />
                        </label>
                    </div>
                </div>
                <div class="col-md mb-md-0 mb-6">
                    <div class="form-check custom-option custom-option-icon mb-0 h-100">
                        <label class="form-check-label custom-option-content" for="valueTypeProfit">
                            <span class="custom-option-body">
                                <i class="ti ti-rosette-discount-check ti-sm"></i>

                                <span class="custom-option-title"> Удержание прибыли </span>
                                <small>Вы указываете прибыль в абсолютном значении, а система подбирает цену</small>
                            </span>
                            <input name="value-type" class="form-check-input" type="radio" value="profit_amount"
                                v-model="localStrategy.pricing_parameters.type" id="valueTypeProfit" />
                        </label>
                    </div>
                </div>
                <div class="col-md mb-md-0 mb-6">
                    <div class="form-check custom-option custom-option-icon mb-0 h-100">
                        <label class="form-check-label custom-option-content" for="valueTypeProfitPercent">
                            <span class="custom-option-body">
                                <i class="ti ti-discount ti-sm"></i>
                                <span class="custom-option-title"> Удержание процента прибыли (от цены) </span>
                                <small>Вы указываете прибыль в процентах от продажной цены, а система подбирает
                                    цену</small>
                            </span>
                            <input name="value-type" class="form-check-input" type="radio" value="profit_percent"
                                v-model="localStrategy.pricing_parameters.type" id="valueTypeProfitPercent" />
                        </label>
                    </div>
                </div>
                <div class="col-md mb-md-0 mb-6">
                    <div class="form-check custom-option custom-option-icon mb-0 h-100">
                        <label class="form-check-label custom-option-content" for="valueTypeProfitPercentCost">
                            <span class="custom-option-body">
                                <i class="ti ti-percentage ti-sm"></i>
                                <span class="custom-option-title"> Удержание процента прибыли (от себестоимости) </span>
                                <small>Вы указываете прибыль в процентах от себестоимости, а система подбирает
                                    цену</small>
                            </span>
                            <input name="value-type" class="form-check-input" type="radio" value="profit_percent_cost"
                                v-model="localStrategy.pricing_parameters.type" id="valueTypeProfitPercentCost" />
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <p>Шаг 2. Укажите, как подбирать товары для этой стратегии</p>
                <div class="col-md mb-md-0 mb-6">
                    <div class="form-check custom-option custom-option-icon mb-0">
                        <label class="form-check-label custom-option-content" for="selectionTypeById">
                            <span class="custom-option-body">
                                <i class="ti ti-click ti-sm"></i>

                                <span class="custom-option-title">Вручную</span>
                                <small>Вы подбираете товары сами. Можете указывать как общие настройки для всех товаров,
                                    так и
                                    по-отдельности для каждого товара.</small>
                            </span>
                            <input name="selection-type" class="form-check-input" type="radio" value="by_id"
                                v-model="localStrategy.product_selection_type" @change="productsSelectionTypeChanged"
                                id="selectionTypeById" />
                        </label>
                    </div>
                </div>
                <div class="col-md mb-md-0 mb-6">
                    <div class="form-check custom-option custom-option-icon mb-0">
                        <label class="form-check-label custom-option-content" for="selectionTypeByFilters">
                            <span class="custom-option-body">
                                <i class="ti ti-filter ti-sm"></i>

                                <span class="custom-option-title"> Автоматически (по фильтрам) </span>
                                <small>Вы указываете фильтры (бренд, себестоимость и т.п.), система подбирает товары
                                    сама.
                                    Доступны только общие настройки для всех товаров. </small>
                            </span>
                            <input name="selection-type" class="form-check-input" type="radio" value="by_filter"
                                v-model="localStrategy.product_selection_type" @change="productsSelectionTypeChanged"
                                id="selectionTypeByFilters" />
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <p>Шаг 3. Укажите, как вы хотите устанавливать {{ getValueTypeName }}</p>
                <div class="col-md mb-md-0 mb-6">
                    <div class="form-check custom-option custom-option-icon mb-0">
                        <label class="form-check-label custom-option-content" for="valueSetTypeForAll">
                            <span class="custom-option-body">
                                <i class="ti ti-device-ipad-horizontal ti-sm"></i>

                                <span class="custom-option-title">Общее значение для всех товаров</span>
                                <small>Вы указываете одно значение для всех товаров в стратегии</small>
                            </span>
                            <input name="value-set-type" class="form-check-input" type="radio" value="for_all"
                                v-model="localStrategy.pricing_parameters.value_set_type" id="valueSetTypeForAll"
                                @change="valueSetTypeChanged" />
                        </label>
                    </div>
                </div>
                <div class="col-md mb-md-0 mb-6" v-if="isActiveValueSetTypeIndividual">
                    <div class="form-check custom-option custom-option-icon mb-0">
                        <label class="form-check-label custom-option-content" for="valueSetTypeIndividual">
                            <span class="custom-option-body">
                                <i class="ti ti-table ti-sm"></i>

                                <span class="custom-option-title">Для каждого товара отдельно</span>
                                <small>Вы редактируете в таблице значения для каждого товара в стратегии</small>
                            </span>
                            <input name="value-set-type" class="form-check-input" type="radio" value="individual"
                                v-model="localStrategy.pricing_parameters.value_set_type" id="valueSetTypeIndividual"
                                @change="valueSetTypeChanged" />
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <p>Шаг 4. Выберите магазин и придумайте название для стратегии</p>
        <div class="col-sm-6">
            <label class="form-label" for="strategyStore">Магазин</label>
            <Select @change="storeChanged()" v-model="localStrategy.store_id" :options="stores" optionLabel="name"
                optionValue="id" id="strategyStore" placeholder="Магазин не выбран" style="width: 100%">
                <template #option="slotProps">
                    <div class="d-flex align-content-center">
                        <img :src="slotProps.option.icon" alt="Маркетплейс" width="20px" style="margin-right: 3px">
                        <span>{{ slotProps.option.name }}</span>
                    </div>
                </template>
            </Select>
        </div>
        <div class="col-sm-6">
            <label class="form-label" for="strategyName">Название стратегии</label>
            <input type="text" class="form-control" v-model="localStrategy.name" id="strategyName">
        </div>
    </div>
</template>

<script>
import { user } from "@/data/user";
import { stores } from "@/data/store";
import { Select } from "primevue";
import Strategy from "@/models/strategy";

export default {
    name: 'StrategySettings',
    components: { Select },
    props: {
        strategy: {
            type: Object,
            required: true
        },
        isNew: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            stores: [],
            localStrategy: new Strategy()
        }
    },
    computed: {
        isActiveValueSetTypeIndividual() {
            return this.localStrategy.product_selection_type !== 'by_filter'
        },
        getValueTypeName() {
            if (this.localStrategy.pricing_parameters.type === 'profit_amount') {
                return 'прибыль'
            }
            if (this.localStrategy.pricing_parameters.type === 'profit_percent') {
                return 'процент прибыли (от цены)'
            }
            if (this.localStrategy.pricing_parameters.type === 'profit_percent_cost') {
                return 'процент прибыли (от себестоимости)'
            }
            if (this.localStrategy.pricing_parameters.type === 'price') {
                return 'цены'
            }
            return ''
        }
    },
    methods: {
        storeChanged() {
            if (this.localStrategy.store_id && this.isNew) {
                const store_info = this.stores.find(obj => obj['id'] === this.localStrategy.store_id);
                if (this.localStrategy.name === 'Без названия' || this.localStrategy.name.includes('Стратегия для магазина')) {
                    this.localStrategy.name = 'Стратегия для магазина ' + store_info.name
                }
            }
        },
        async productsSelectionTypeChanged() {
            if (this.localStrategy.product_selection_type === 'by_filter') {
                this.localStrategy.pricing_parameters.value_set_type = 'for_all'
                if (!this.localStrategy.filters) {
                    this.localStrategy.filters = {
                        company: await user.getActiveCompany()
                    }
                }
            }
        },
        valueSetTypeChanged() {
            if (this.localStrategy.pricing_parameters.value_set_type === 'for_all') {
                this.localStrategy.pricing_parameters.value_individual = null
            }
            if (this.localStrategy.pricing_parameters.value_set_type === 'individual') {
                this.localStrategy.pricing_parameters.value_individual = {}
                this.localStrategy.pricing_parameters.value_for_all = null
            }
        },
    },
    watch: {
        strategy: {
            handler(newVal) {
                if (JSON.stringify(this.localStrategy) !== JSON.stringify(newVal)) {
                    this.localStrategy = new Strategy(newVal)
                }
            },
            deep: true,
            immediate: true
        },
        localStrategy: {
            handler(newVal) {
                if (JSON.stringify(this.strategy) !== JSON.stringify(newVal)) {
                    this.$emit('update:strategy', newVal)
                }
            },
            deep: true
        }
    },
    async mounted() {
        this.stores = await stores.getStores()
    },
}
</script>
<style scoped>
.strategy-type-row > [class*="col-"] {
  display: flex;
}

.strategy-type-row .custom-option {
  width: 100%;
  display: flex;
}

.strategy-type-row .custom-option-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}
</style>
